import {
  EXPERIMENT_VARIATION,
  REBRANDING_COM_TOGGLE,
  REBRANDING_TOGGLE,
} from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

export const isRebrandingActive = (experiments: Experiment[] = []): boolean => {
  const [experiment] = getExperiments([REBRANDING_TOGGLE], experiments)
  return !!experiment?.isEnabled
}

export const isRebrandingCOMActive = (
  experiments: Experiment[] = []
): boolean => {
  const [experiment] = getExperiments([REBRANDING_COM_TOGGLE], experiments)

  const isCOMExperiment =
    experiment?.variant === EXPERIMENT_VARIATION.V1 ||
    experiment?.variant === EXPERIMENT_VARIATION.V2 ||
    experiment?.variant === EXPERIMENT_VARIATION.V3 ||
    experiment?.variant === EXPERIMENT_VARIATION.V4

  return !!(experiment?.isEnabled && isCOMExperiment)
}

export const isRebrandingCOMColorExperimentActive = (
  experiments: Experiment[] = []
): boolean => {
  const [experiment] = getExperiments([REBRANDING_COM_TOGGLE], experiments)

  const isColorExperiment =
    experiment?.variant === EXPERIMENT_VARIATION.V2 ||
    experiment?.variant === EXPERIMENT_VARIATION.V3 ||
    experiment?.variant === EXPERIMENT_VARIATION.V4

  return !!(experiment?.isEnabled && isColorExperiment)
}
